import React from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import { Link, Typography } from "@mui/material";
import { readSimpleValue, saveSimpleValue } from "./localStorageManager";
import { toast } from "react-toastify";
import { toastStyles } from "../TaxGuruStyles";

export default function NewVersionAnnounceComponent({ version }: { version: string }) {
    const { t } = useTranslation();

    return (
        <Stack>
            <Typography>{t("common.version.announce", { version })}</Typography>
            <Link color="inherit" onClick={() => window.location.reload()}>
                {t("common.version.clickToRefresh")}
            </Link>
        </Stack>
    );
}

export const announceNewVersion = ({ version }: { version: string }) => {
    const storedVersion = readSimpleValue("TAX_VERSION");
    if (storedVersion !== version) {
        saveSimpleValue("TAX_VERSION", version);
        toast.info(<NewVersionAnnounceComponent version={version} />, {
            autoClose: false,
            style: toastStyles.info,
            toastId: `newVersion-${version}`,
        });
    }
};
